import list from './list'
import edit from './edit'

export default { list, edit, options: { label: 'Attempts / Balls' } }
